import { createFileRoute } from '@tanstack/react-router'

import { CleanupSection } from '@/components/Internal/ListingCleanup/CleanupSection'

export const Route = createFileRoute('/internal/system/settings/cleanup')({
  component: CleanupSection,
})
